import { Control, Controller } from 'react-hook-form';
import { IEnquiryDto } from '../model';
import { useTranslation } from 'react-i18next';
import { StyledButton, StyledInput } from '../ui';
import { useState } from 'react';

export interface IAddressFormProps {
  control: Control<IEnquiryDto, any>;
}

export function AddressForm(props: IAddressFormProps) {
  const { t } = useTranslation();
  const { control } = props;

  const [showAddress, setShowAddress] = useState<boolean>(true);

  return (
    <>
      {!showAddress && (
        <div className="sm:col-span-6">
          <StyledButton
            design="default"
            type="button"
            onClick={() => setShowAddress(true)}
          >
            {t('personal.enter-address')}
            <span className="text-slate-600 text-sm ms-1">{' (optional)'}</span>
          </StyledButton>
        </div>
      )}

      {showAddress && (
        <>
          <div className="sm:col-span-4">
            <Controller
              name="contactStreet"
              control={control}
              render={(s) =>
                StyledInput({
                  ...s,
                  title: t('personal.street'),
                  hint: '(optional)',
                  autoComplete: 'section-contact address-line1',
                })
              }
            />
          </div>

          <div className="sm:col-span-2">
            <Controller
              name="contactStreetNr"
              control={control}
              render={(s) =>
                StyledInput({
                  ...s,
                  title: t('personal.number'),
                  hint: '(optional)',
                  autoComplete: 'off',
                })
              }
            />
          </div>

          <div className="sm:col-span-1">
            <Controller
              name="contactPostal"
              control={control}
              render={(s) =>
                StyledInput({
                  ...s,
                  title: t('personal.postal'),
                  hint: '(optional)',
                  autoComplete: 'section-contact postal-code',
                })
              }
            />
          </div>

          <div className="sm:col-span-3">
            <Controller
              name="contactCity"
              control={control}
              render={(s) =>
                StyledInput({
                  ...s,
                  title: t('personal.city'),
                  hint: '(optional)',
                  autoComplete: 'section-contact address-level2',
                })
              }
            />
          </div>

          <div className="sm:col-span-2">
            <Controller
              name="contactCountry"
              control={control}
              render={(s) =>
                StyledInput({
                  ...s,
                  title: t('personal.country'),
                  hint: '(optional)',
                  autoComplete: 'section-contact country-name',
                })
              }
            />
          </div>
        </>
      )}
    </>
  );
}

export default AddressForm;
